import React, { useState } from 'react';
import './RegisterForm.css';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const Register = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: ''
  });

  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({...formData, [e.target.name]: e.target.value});
  };

  const handleSubmit =async (e) => {
    e.preventDefault();
    let baseUrl = "";
    if (process.env.NODE_ENV === "production") {
      baseUrl = "https://imw-edu.com/edubackend";
    } else {
      baseUrl = "http://localhost/edubackend";
    }
    const url = `${baseUrl}/userregister.php`;
   await axios.post(url, formData)
      .then(res => {
        alert(res.data.message);
        if (res.data.status === 200) {
          navigate('/login'); // Redirect to login page on successful registration
        }
      })
      .catch(err => {
        console.error('Registration error:', err);
      });
  };

  return (
    <div className="register-container">
      <form className="register-form" onSubmit={handleSubmit}>
        <h2>Register</h2>

        <label htmlFor="name">Name</label>
        <input
          type="text"
          name="name"
          placeholder="Enter your name"
          value={formData.name}
          onChange={handleChange}
          required
        />

        <label htmlFor="email">Email</label>
        <input
          type="email"
          name="email"
          placeholder="Enter your email"
          value={formData.email}
          onChange={handleChange}
          required
        />

        <label htmlFor="password">Password</label>
        <input
          type="password"
          name="password"
          placeholder="Enter your password"
          value={formData.password}
          onChange={handleChange}
          required
        />

        <button type="submit">Register</button>
      </form>
    </div>
  );
};

export default Register;
